import { render } from "./MentalDetail.vue?vue&type=template&id=2f26727b"
import script from "./MentalDetail.vue?vue&type=script&lang=js"
export * from "./MentalDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__